import { Instance } from 'mobx-state-tree';
import { ProjectRouteStopMovedDtoModelBase } from './ProjectRouteStopMovedDtoModel.base';

/* The TypeScript type of an instance of ProjectRouteStopMovedDtoModel */
export interface ProjectRouteStopMovedDtoModelType extends Instance<typeof ProjectRouteStopMovedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectRouteStopMovedDtoModel */
export { selectFromProjectRouteStopMovedDto, projectRouteStopMovedDtoModelPrimitives, ProjectRouteStopMovedDtoModelSelector } from './ProjectRouteStopMovedDtoModel.base';

/**
 * ProjectRouteStopMovedDtoModel
 *
 * Stop unscheduling
 */
export const ProjectRouteStopMovedDtoModel = ProjectRouteStopMovedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
